// Typed read of Vite's `import.meta.env`. Centralises the var names so a
// rename only touches one place + makes the missing-var error clear.

interface RuntimeEnv {
  PAYLOAD_URL: string;
  API_BASE_URL: string;
}

function read(name: string): string {
  const raw = (import.meta.env as Record<string, string | undefined>)[name];
  if (!raw) {
    throw new Error(`${name} is not set. Add it to apps/backoffice/.env or the deploy env.`);
  }
  return raw.replace(/\/$/, '');
}

let cached: RuntimeEnv | null = null;

export function env(): RuntimeEnv {
  if (cached) return cached;
  cached = {
    PAYLOAD_URL: read('VITE_PAYLOAD_URL'),
    API_BASE_URL: read('VITE_API_BASE_URL'),
  };
  return cached;
}
